export function stripFroalaWatermark(html: string): string {
    if (!html) return html;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    doc.querySelectorAll('[data-f-id="pbf"]').forEach(el => el.remove());
    return doc.body.innerHTML;
}

// Froala sets role="application" on its outer wrapper ($box, the ".fr-box" element), which puts
// screen readers into application mode for everything inside it as soon as focus reaches any
// descendant - overriding the role on the contenteditable element alone doesn't help, since the
// ancestor's "application" role still wins. Strip it and set role="textbox" (with aria-multiline)
// on the actual editable element so screen readers stay in browse/reading mode.
//
// Note: in the non-iframe case (the only mode used here), $el IS the ".fr-element[contenteditable]"
// div itself - searching its descendants for that selector (as a prior version of this fix did)
// always returned null, silently no-opping the role override.
export function applyFroalaAriaFix(options: any): any {
    const existingInit = options?.events?.initialized;
    if (!options.events) options.events = {};
    options.events.initialized = function(this: any) {
        const box: HTMLElement | null = this.$box?.[0];
        if (box) box.removeAttribute('role');

        const editable: HTMLElement | null = this.$el?.[0] ?? box?.querySelector('.fr-element[contenteditable]');
        if (editable) {
            editable.setAttribute('role', 'textbox');
            editable.setAttribute('aria-multiline', 'true');
        }
        if (existingInit) existingInit.call(this);
    };
    return options;
}
